var r, n = (a) => {
  r = a;
}, d = () => {
  r?.();
};
export {
  d as notifyAdminUnauthorized,
  n as setAdminUnauthorizedHandler
};

//# sourceMappingURL=unauthorized.js.map